import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Measurements from "@/components/Measurements";
import { Skeleton } from "@/components/ui/skeleton";

export default function MemberMeasurements() {
  const [me, setMe] = useState(null);
  useEffect(() => { api.get("/members/me").then((r) => setMe(r.data)).catch(() => setMe(false)); }, []);

  if (me === null) return <Skeleton className="h-64 rounded-2xl bg-[#13131C]" />;
  if (!me) return <div className="text-center py-20 text-[#68687B]">Üye profili bulunamadı.</div>;

  return (
    <div data-testid="member-measurements-page">
      <h1 className="font-display font-extrabold text-2xl text-white mb-1">Ölçümlerim</h1>
      <p className="text-sm text-[#68687B]">Gelişimini takip et</p>
      <Measurements memberId={me.id} canEdit={false} />
    </div>
  );
}
